var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { loadStripe } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { H3 } from 'shared-assets/components/Elements';
import PaymentCardForm, { Elements, GRID_SPACING, } from 'shared-assets/components/PaymentCardForm';
var defaultProps = {
    formId: 'new-card-form',
    makeDefaultCard: false,
    showMakeDefaultCard: false,
    showSaveCard: false,
    showSubmit: true,
    showTitle: true,
    showCancel: false,
};
var NewCard = function (props) {
    var _a = __assign(__assign({}, defaultProps), props), addressCity = _a.addressCity, addressLine1 = _a.addressLine1, addressState = _a.addressState, addressZipcode = _a.addressZipcode, formId = _a.formId, kareoStripeApiKey = _a.kareoStripeApiKey, makeDefaultCard = _a.makeDefaultCard, onAuthorize = _a.onAuthorize, onError = _a.onError, onSubmit = _a.onSubmit, showSubmit = _a.showSubmit, showMakeDefaultCard = _a.showMakeDefaultCard, showSaveCard = _a.showSaveCard, showTitle = _a.showTitle, showCancel = _a.showCancel, onCancel = _a.onCancel;
    var _b = useState(), stripePromise = _b[0], setStripePromise = _b[1];
    useEffect(function () {
        if (kareoStripeApiKey) {
            setStripePromise(loadStripe(kareoStripeApiKey));
        }
    }, [kareoStripeApiKey]);
    return (React.createElement(Grid, { container: true, spacing: GRID_SPACING },
        showTitle && (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(H3, null, "Enter a Card"))),
        React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Grid, { container: true, spacing: GRID_SPACING },
                React.createElement(Grid, { item: true, xs: 12 }, stripePromise && (React.createElement(Elements, { stripe: stripePromise },
                    React.createElement(PaymentCardForm, { authorizeButtonText: "Save Card", city: addressCity, formId: formId, line1: addressLine1, makeDefaultCard: makeDefaultCard, postalCode: addressZipcode, showMakeDefaultCard: showMakeDefaultCard, showSaveCard: showSaveCard, showSubmit: showSubmit, showCancel: showCancel, onCancel: onCancel, state: addressState, stripeApiKey: kareoStripeApiKey, onAuthorize: function (response) {
                            if (onAuthorize) {
                                onAuthorize(response);
                            }
                        }, onError: function (error) {
                            if (onError) {
                                onError(error);
                            }
                        }, onSubmit: function (response) {
                            if (onSubmit) {
                                onSubmit(response);
                            }
                        } }))))))));
};
export default NewCard;
